<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="3000">
      <span v-if="snackbar_msg != null">
        <v-icon color="white">warning</v-icon>
        <span style="padding-left: 50px"></span>{{ snackbar_msg }}
      </span>
    </v-snackbar>
    <v-app>
      <div class="d-flex flex-column fill-height">
        <v-row justify="center">
          <v-col cols="12" lg="6" class="align-center justify-center">
            <!-- <v-row dense justify="center">
              <div
                class="card"
                :class="{ 'hover-effect': animateCard }"
                @mouseenter="hovering = true"
                @mouseleave="hovering = false"
              >
                <div class="card-details">
                  <p
                    class="text-title"
                    :class="{ shrink: animateCard || hovering }"
                  >
                    User Manual
                  </p>
                </div>
                <button
                  class="card-button"
                  onclick="window.open('https://www.youtube.com/channel/UCisFmSqTOFXMcpb7GlmE_7A/playlists', '_blank')"
                >
                  <v-icon small color="white" class="mr-1">mdi-youtube</v-icon>
                  Watch Video
                </button>
              </div>
            </v-row> -->
            <br />
            <v-img alt="Sample image"
              src="https://vierp-test.s3.ap-south-1.amazonaws.com/logo/edupluscampus_banner.jpg"></v-img>
          </v-col>
          <v-col cols="12" lg="6" align="center">
            <v-row dense style="align-items: center; justify-content: center">
              <v-col cols="12" sm="2" md="2" v-if="trust_logo">
                <img class="shrink mr-2 logo" contain :src="trust_logo" />
              </v-col>
              <v-col cols="12" sm="7" md="7" align="center" v-if="school_name">
                <span class="blue-theme text-h1">{{ school_name }}</span>
              </v-col>
              <!-- <v-col cols="12" sm="2" md="2" v-if="logo">
                <img class="shrink mr-2 logo" contain :src="logo" />
              </v-col> -->
            </v-row>
            <h2 class="font-weight-bold">
              <span class="blue-theme"> Sign </span><span class="yellow-theme"> - In</span>
            </h2>
            <v-col cols="12" align="left">
              <span class="ml-8" style="font-size: 12px;">Username</span>
              <v-text-field class="pt-0 mt-0" :rules="[rules.required, rules.uid]" color="primary"
                v-model.trim="user.uid" prepend-icon="mdi-account" variant="underlined"></v-text-field>
              <span class="ml-8" style="font-size: 12px;">Password</span>
              <v-text-field class="pt-0 mt-0" color="primary" v-model="user.pass"
                :rules="[(v) => !!v || 'password required']" prepend-icon="mdi-lock"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" counter
                @click:append="show1 = !show1">
              </v-text-field>

              <div style="display: none">
                <altcha-widget
                  ref="altcha"
                  :challengeurl="challengeUrl"
                  @statechange="onAltchaStateChange"
                ></altcha-widget>
              </div>

              <v-row no-gutters justify="center">
                <v-btn color="primary" rounded type="submit" @click="triggerSignIn" :loading="login">Login
                </v-btn>
              </v-row> </v-col>
            <v-container fluid>
              <v-row dense>
                <v-col cols="6" xs="6" sm="6" md="6" class="d-flex align-start justify-start">
                  <div @click="openDialog" style="cursor: pointer">
                    <v-icon color="primary" class="mr-2">mdi mdi-card-account-phone</v-icon>
                    <span class="text-decoration-underline"><strong>Contact</strong></span>
                  </div>
                </v-col>

                <v-col cols="6" xs="6" sm="6" md="6" class="d-flex align-start justify-end">
                  <div>
                    <v-icon class="mr-2" color="primary">mdi-lock-open</v-icon>
                    <router-link to="/forgot-password"><strong>Forgot Password?</strong></router-link>
                  </div>
                </v-col>

                <v-col cols="6" xs="6" sm="6" md="6" class="d-flex flex-column align-start justify-start mt-4">
                  <div v-if="show_quick_pay" class="mb-2">
                    <v-icon color="primary" class="mr-2">mdi-link-variant</v-icon>
                    <router-link to="/quick-pay"><strong>Quick Pay</strong></router-link>
                  </div>
                  <div v-if="show_career_advice">
                    <v-icon class="mr-3" color="primary">mdi-account-group</v-icon>
                    <a href="https://sbpatilschool.com/career-counselling.php" target="_blank">
                      <strong>Career Advice?</strong>
                    </a>
                  </div>
                </v-col>

                <v-col cols="6" xs="6" sm="6" md="6" class="d-flex flex-column align-end justify-end mt-4">
                  <div v-if="show_parent_sign_up" class="mb-2">
                    <v-icon class="mr-2" color="primary">mdi-account-plus</v-icon>
                    <router-link to="/parent-signup"><strong>New Parent Signup</strong></router-link>
                  </div>
                  <div v-if="show_pwd_guide">
                    <v-icon color="primary" class="mr-3">mdi-text-box</v-icon>
                    <a href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sbpps_docs/ERP+Password+Guide.pdf"
                      target="_blank">
                      <strong>ERP Password Guide</strong>
                    </a>
                  </div>
                </v-col>
              </v-row>
            </v-container>


            <v-row justify="center" class="px-5" v-if="
              learner_ios_url ||
              learner_android_url ||
              inst_ios_url ||
              inst_android_url
            ">
              <!-- Learner App Block -->
              <v-col cols="12" sm="5" md="5" v-if="learner_ios_url || learner_android_url">
                <span class="pr-5" v-if="learner_ios_url">
                  <a target="_blank" :href="learner_ios_url">
                    <img style="height: 36px; width: 100px"
                      src="https://vierp-test.s3.ap-south-1.amazonaws.com/logo/ios.jpeg" name="ios" />
                  </a>
                </span>

                <span v-if="learner_android_url">
                  <a target="_blank" :href="learner_android_url">
                    <img style="height: 36px; width: 100px"
                      src="https://vierp-test.s3.ap-south-1.amazonaws.com/logo/android.jpeg" name="android" />
                  </a>
                </span>

                <div v-if="learner_ios_url || learner_android_url">
                  <h5>Parent / Student App</h5>
                </div>
              </v-col>

              <v-col cols="12" sm="2" md="2" v-if="
                (learner_ios_url || learner_android_url) &&
                (inst_ios_url || inst_android_url)
              "></v-col>

              <v-col cols="12" sm="5" md="5" v-if="inst_ios_url || inst_android_url">
                <span class="pr-5" v-if="inst_ios_url">
                  <a target="_blank" :href="inst_ios_url">
                    <img style="height: 36px; width: 100px"
                      src="https://vierp-test.s3.ap-south-1.amazonaws.com/logo/ios.jpeg" name="ios" />
                  </a>
                </span>

                <span v-if="inst_android_url">
                  <a target="_blank" :href="inst_android_url">
                    <img style="height: 36px; width: 100px"
                      src="https://vierp-test.s3.ap-south-1.amazonaws.com/logo/android.jpeg" name="android" />
                  </a>
                </span>

                <div v-if="inst_android_url || inst_ios_url">
                  <h5>Teacher App</h5>
                </div>
              </v-col>
            </v-row>

            <v-row dense>
              <!-- <v-col cols="12" sm="6" md="6"
                ><h5 v-if="learner_android_url || learner_ios_url">
                  Parent / Student App
                </h5></v-col
              >
              <v-col cols="12" sm="6" md="6"
                ><h5 v-if="inst_android_url || inst_ios_url">
                  Teacher App
                </h5></v-col
              > -->
              <v-col cols="12" sm="12" md="12" class="mt-6" align="center" v-if="school_code"
                style="text-decoration: underline">School Code for Mobile App : <b>{{ school_code }}</b>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-dialog v-model="showDialog" max-width="1200">
          <div class="dialog">
            <v-row dense>
              <v-col cols="12" sm="11" md="11" align="center" class="pt-0">
                <h3 class="pl-10 ml-7">Helpline Contact</h3>
              </v-col>
              <v-col cols="12" sm="1" md="1" align="right" class="pt-0">
                <v-btn class="close-button pr-0" text @click="closeDialog">X</v-btn>
              </v-col>
            </v-row>
            <div class="" style="max-height: 400px; overflow-y: auto">
              <v-simple-table style="border: 1px solid lightgray" fixed-header>
                <thead class="custom-table-header">
                  <tr style="font-weight: bold; height: 60px">
                    <th class="text-left">Sr.No</th>
                    <th class="text-left">Institute Name</th>
                    <th class="text-left">Official Query Contact</th>
                    <th class="text-left">Official Query Email</th>
                    <!-- <th class="text-left">Technical Query Contact</th> -->
                    <th class="text-left">Technical Query Email</th>
                    <th class="text-left">Days & Timings for Contacts</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="help_details.length > 0">
                    <tr v-for="(item, index) in help_details" :key="item.id">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.official_query_contact }}</td>
                      <td>{{ item.official_query_email }}</td>
                      <!-- <td>{{ item.technical_query_contact }}</td> -->
                      <td>{{ item.technical_query_email }}</td>
                      <td>{{ item.day_and_timing_of_contact }}</td>
                    </tr>
                  </template>
                  <tr v-else>
                    <td colspan="7" class="text-center">
                      <strong>No contact details available</strong>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
          </div>
        </v-dialog>
        <v-row justify="center" v-if="this.update_password_dialog == true">
          <v-dialog v-model="update_password_dialog" max-width="500px">
            <v-card>
              <v-card-title class="justify-center">
                <span class="">Update Password</span>
              </v-card-title>
              <v-card-text>
                <v-text-field v-model="user_1.oldpassword" :rules="[(v) => !!v || 'Old Password is required']"
                  prepend-icon=" mdi-account-key" placeholder="Current Password"
                  :disabled="disabled == 1 ? true : false" clearable :append-icon="value2 ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="() => (value2 = !value2)" :type="value2 ? 'password' : 'text'" required></v-text-field>
                <div class="error-message" v-if="error">
                  {{ error_message }}
                </div>
                <v-layout align-center justify-center v-if="hideen">
                  <v-btn class="mr-4" color="primary" @click="validateoldpassword">Check Password</v-btn>
                </v-layout>
                <v-text-field v-if="!hideen" v-model="user_1.password" :rules="[(v) => !!v || 'Password is required']"
                  prepend-icon=" mdi-account-key" placeholder="New Password" clearable
                  :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'" @click:append="() => (value = !value)"
                  :type="value ? 'password' : 'text'" hint="*Please enter a strong password." required></v-text-field>
                <div class="error-message" v-if="error">
                  {{ error_message }}
                </div>
                <div v-if="!hideen" class="captcha-container">
                  <v-row justify="center" align="center" class="mb-2">
                    <v-col cols="auto">
                      <img :src="captchaImage" @click="loadCaptcha" class="captcha-image" />
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center" class="captcha-input-row">
                    <v-col cols="auto" class="pr-2">
                      <v-text-field v-model="userCaptcha" placeholder="Enter CAPTCHA" dense hide-details
                        class="captcha-input" prepend-inner-icon="mdi-shield-check"
                        :rules="[(v) => !!v || 'CAPTCHA is required']" outlined style="min-width: 180px;" />
                    </v-col>
                    <v-col cols="auto">
                      <v-btn color="#1976D2" dark @click="verifyCaptcha" class="captcha-verify-btn" small>
                        Verify
                      </v-btn>
                    </v-col>
                  </v-row>
                  <p v-if="message" :style="{ color: success ? 'green' : 'red' }" class="captcha-message">
                    {{ message }}
                  </p>
                  <div class="error-message" v-if="error1">
                    {{ error_message1 }}
                  </div>
                </div>

                <v-layout align-center justify-center v-if="!hideen">
                  <v-btn class="mr-4" color="primary" @click="setpassword">Change Password</v-btn>
                </v-layout>
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn class="dialog-btn" @click="update_password_dialog = false">Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
        <div class="text-center">
          <v-dialog v-model="dialog" width="500">
            <v-card>
              <v-card-title class="headline grey lighten-2" primary-title>
                Privacy Policy
              </v-card-title>

              <v-card-text>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
                reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="readPolicy()" :loading="read_policy_load">
                  I accept
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="qrModal" max-width="800" persistent>
            <v-card>

              <v-card-title class="primary white--text">
                Two Factor Verification
                <v-spacer></v-spacer>

                <v-btn icon dark @click="qrModal = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>

              <v-card-text class="pt-4">

                <!-- BOTH MFA + EMAIL -->
                <div v-if="bothVerificationMode">

                  <v-tabs
                    v-model="activeVerificationTab"
                    background-color="primary"
                    dark
                    grow
                  >
                    <v-tab>
                      <v-icon left>mdi-shield-lock</v-icon>
                      Verification By MFA
                    </v-tab>

                    <v-tab>
                      <v-icon left>mdi-email-check</v-icon>
                      Verification By Email
                    </v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="activeVerificationTab" class="mt-4">

                    <!-- MFA TAB -->
                    <v-tab-item>
                      <v-container>

                        <div
                          v-if="mfaSetupMode"
                          class="text-center mb-5"
                        >
                          <qrcode-vue
                            :value="qrdetails"
                            :size="220"
                            v-if="qrdetails"
                          />

                          <p class="mt-4 grey--text text--darken-1">
                            Scan this QR code using Google Authenticator
                            or any compatible authenticator application.
                          </p>
                        </div>

                        <v-text-field
                          v-model="totpCode"
                          prepend-icon="mdi-lock"
                          label="Enter 6 Digit Authenticator Code"
                          placeholder="000000"
                          maxlength="6"
                          outlined
                          dense
                        />

                        <div class="text-center mt-4">
                          <v-btn
                            color="primary"
                            :loading="mfaLoading"
                            @click="handleMfaSubmit"
                          >
                            {{ mfaSetupMode ? "Verify & Register" : "Verify & Login" }}
                          </v-btn>
                        </div>

                      </v-container>
                    </v-tab-item>

                    <!-- EMAIL TAB -->
                    <v-tab-item>
  <v-container>

    <v-row justify="center">
      <v-col cols="12" md="8">

        <v-text-field
          label="Username"
          v-model="user_otp.otp_send_username"
          readonly
          outlined
        />

        <v-text-field
          label="Enter OTP"
          v-model="user_otp.new_otp"
          outlined
        />

        <div class="text-center">

          <v-btn
            color="primary"
            :loading="verify_btn_load"
            @click="verifyotp"
          >
            Verify OTP
          </v-btn>

        </div>

      </v-col>
    </v-row>

  </v-container>
</v-tab-item>

                  </v-tabs-items>

                </div>

                <!-- ONLY MFA FLOW -->
                <div v-else>

                  <div
                    v-if="mfaSetupMode"
                    class="text-center mb-5"
                  >
                    <qrcode-vue
                      :value="qrdetails"
                      :size="220"
                      v-if="qrdetails"
                    />

                    <p class="mt-4 grey--text text--darken-1">
                      Scan this QR code using Google Authenticator
                      or any compatible authenticator application.
                    </p>
                  </div>

                  <v-text-field
                    v-model="totpCode"
                    prepend-icon="mdi-lock"
                    label="Enter 6 Digit Authenticator Code"
                    placeholder="000000"
                    maxlength="6"
                    outlined
                    dense
                    @keyup.enter="handleMfaSubmit"
                  />

                  <div class="text-center mt-4">
                    <v-btn
                      color="primary"
                      :loading="mfaLoading"
                      @click="handleMfaSubmit"
                    >
                      {{ mfaSetupMode ? "Verify & Register" : "Verify & Login" }}
                    </v-btn>
                  </div>

                </div>

              </v-card-text>

            </v-card>
          </v-dialog>

          <v-dialog v-model="otp_based_login_dialog" width="800" persistent>
            <v-card>
              <v-card-title class="toolbar" flat dense>OTP Based Login</v-card-title>
              <v-card-text>
                <v-row justify="center" dense>
                  <v-col cols="12" sm="4" md="4" class="pt-3">
                    <b>Username</b> <v-icon color="error">*</v-icon>
                    <v-text-field color="#0F2027" dense required class="mt-4" v-model="user_otp.otp_send_username" disabled
                      readonly filled label="Username" outlined :loading="send_otp_btn_load"></v-text-field>
                  </v-col>
                </v-row>
                <v-row justify="center" dense>
                  <v-col cols="12" sm="4" md="4" class="pt-3" v-if="verify_block == true">
                    <b>OTP</b> <v-icon color="error">*</v-icon>
                    <v-text-field color="#0F2027" dense required class="mt-4" v-model="user_otp.new_otp" label="Enter OTP"
                      outlined></v-text-field>
                  </v-col>
                </v-row>
                <v-row justify="center" dense>
                  <!-- <v-col cols="12" sm="3" md="4" class="pt-8"></v-col> -->
                  <!-- <v-btn class="button" :loading="send_otp_btn_load"
                    v-if="!user_otp.new_otp || user_otp.new_otp.trim() === ''" @click="sendotp()" type="submit">
                    Send OTP
                  </v-btn> -->

                  <!-- Show 'Verify OTP' button only when OTP field has ANY input -->
                  <v-btn class="button" :loading="verify_btn_load" v-if="user_otp.new_otp && user_otp.new_otp.trim() !== ''"
                    @click="verifyotp()" type="submit">
                    Verify OTP
                  </v-btn>
                </v-row>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="otp_based_login_dialog = false">Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
        <newLoginFooter></newLoginFooter>
      </div>
    </v-app>
  </div>
</template>

<script>
import axios from "axios";
import epsLoginHeader from "../LoginHeader.vue";
import newLoginFooter from "../FooterNew1.vue";
import QrcodeVue from 'qrcode.vue'
export default {
  components: {
    epsLoginHeader: epsLoginHeader,
    newLoginFooter: newLoginFooter,
    QrcodeVue
  },
  data() {
    return {
      show1: false,
      showDialog: false,
      animateCard: false,
      hovering: false,
      help_details: [],
      school_code: null,
      inst_ios_url: "",
      inst_android_url: "",
      learner_ios_url: "",
      learner_android_url: "",
      login: false,
      app_link: true,
      ios_link: null,
      learner_ios_link: null,
      learner_android_link: null,
      android_link: null,
      hideen: true,
      read_policy_load: false,
      dialog: false,
      error: false,
      is_des_school: false,
      verify_block:false,
      user_otp: {
        otp_send_username: "",
        otp_send_password:"",
        new_otp: "",
        dns: "",
      },
      user_1: {
        uid: "",
        oldpassword: "",
        password: "",
      },
      user: {
        uid: "",
        pass: "",
      },
      value: String,
      captchaImage: "",
      captchaToken: "",
      userCaptcha: "",
      error1: false,
      error_message1: '',
      success: false,
      message: "",
      snackbar_msg: "",
      color: "",
      snackbar: false,
      load: false,
      dialog: false,
      trust_logo: null,
      school_name: null,
      logo: "",
      update_password_dialog: false,
      show_quick_pay: false,
      show_parent_sign_up: false,
      show_career_advice: false,
      show_pwd_guide: false,
      otp_based_login_dialog: false,
      verify_btn_load: false,
      qrModal: false,
      qrdetails: "",
      mfaSecret: "",
      totpCode: "",
      mfaSetupMode: false,
      mfaLoading: false,
      send_otp_btn_load:false,
      bothVerificationMode: false,
      activeVerificationTab: 0,
      emailOtpSent: false,

      // ALTCHA variables
      altchaPayload: null,
      challengeUrl: "",
      pendingAction: null,
      rules: {
        required: (value) => !!value || "Required.",
        // uid: (value) => {
        //   const pattern =
        //     // /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        //     /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        //   return pattern.test(value) || "Invalid e-mail.";
        // },
        uid: (value) => {
          const emailPattern =
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

          const numberPattern = /^[0-9]+$/;

          if (this.is_des_school) {
            return (
              emailPattern.test(value) || numberPattern.test(value) || "Invalid Login Id."
            );
          } else {
            return emailPattern.test(value) || "Invalid e-mail.";
          }
        },
      },
    };
  },
  mounted() {
    this.challengeUrl = process.env.VUE_APP_API_URL + "Altcha/challenge";
    sessionStorage.removeItem("para_role");
    sessionStorage.removeItem("para_role_type");
    var url = window.location.href;
    this.show_quick_pay = true;
    this.show_parent_sign_up = true;
    if (url.includes("sbpps")) {
      this.show_quick_pay = false;
      this.show_parent_sign_up = true;
      this.show_pwd_guide = true;
      this.show_career_advice = true;
    } else if (url.includes("localhost")) {
      this.show_parent_sign_up = false;
    } else if (url.includes("wisdomworldschool")) {
      this.show_parent_sign_up = true;
    } else if (url.includes("universalwisdomschool")) {
      this.show_quick_pay = false;
    } else if (url.includes("vvp.edupluscampus")) {
      this.show_parent_sign_up = false;
    } else if (url.includes("zealerp")) {
      this.show_parent_sign_up = true;
      this.show_quick_pay = true;
    } else if (url.includes("school.despune")) {
      this.show_parent_sign_up = false;
      this.show_quick_pay = false;
      this.is_des_school = true;
    }
    else {
    }
    this.message = localStorage.getItem("login-page-msg");
    if (this.message) {
      this.showSnackbar("#C62828", this.message);
    }
    console.log("login-page-msg>>" + localStorage.getItem("login-page-msg"));

    this.$store.commit("setquick_links", false);
    this.$store.commit("setcalendar_flag", false);
    this.$store.commit("settoday_events", false);

    localStorage.clear();
    if (this.$session.exists()) {
      this.$session.destroy();
    }
    this.animateCard = true;

    // Reset after 3 seconds
    setTimeout(() => {
      this.animateCard = false;
    }, 2000);
    this.getlogo();
    this.dns = window.location.hostname;
    this.loadCaptcha();

  },
  watch: {
    userCaptcha(newValue) {
      // Clear CAPTCHA-related errors when user types or clears the CAPTCHA field
      if (this.error1 && (this.error_message1 === 'Please enter CAPTCHA' || this.error_message1 === 'Please verify CAPTCHA')) {
        this.error1 = false;
        this.error_message1 = '';
      }
    },
    activeVerificationTab(newVal) {
      if (this.bothVerificationMode && newVal === 1 && !this.otp_based_login_dialog) {
        // this.sendotp();
        this.triggerSendOtp();
      }
  },

  },
  methods: {
    open_dialog_for_send_otp() {
      // this.otp_based_login_dialog = true;
      this.bothVerificationMode = false;
      this.user_otp.otp_send_username = this.user.uid;
      this.user_otp.otp_send_password = this.user.pass;
      // this.sendotp();
      this.triggerSendOtp();
    },

     sendotp() {
      if (this.user_otp.otp_send_username == "" || this.user_otp.otp_send_username == null) {
        this.message = "Please Enter Username";
        return;
      }
      if (this.user_otp.otp_send_password == "" || this.user_otp.otp_send_password == null) {
        this.message = "Please Enter Password";
        return;
      }

      this.send_otp_btn_load = true;
      this.user_otp.dns = window.location.hostname;
      this.user_otp.altchaPayload = this.altchaPayload;
      axios
        .post("/login/sendOtpForLogin", this.user_otp)
        .then((res) => {
          if (res.data.status == "NO") {
            alert(res.data.msg || res.data.status_reason);
          } else {
            // this.otp_based_login_dialog = true;
            if (!this.bothVerificationMode) {
                this.otp_based_login_dialog = true;
            }

            this.verify_block = true;
            this.showSnackbar("#4caf50", res.data.email_msg);
          }
        })
        .catch((error) => {
          window.console.log(error);
          this.message = "Something went wrong";
        })
        .finally(() => {
          this.send_otp_btn_load = false;
          this.login = false;
        });

    },

     verifyotp() {
      if (this.user_otp.new_otp != "") {
        this.verify_btn_load = true;
        const formData = {
          email: this.user_otp.otp_send_username,
          email_otp: this.user_otp.new_otp,
          dns: window.location.hostname,
        };
        axios
          .post("/login/verifyotpForLogin", formData)
          .then((res) => {
            if (res.data.status == "YES") {
              this.showSnackbar("green", res.data.status_reason);
              (this.verify_block = false), 
              (this.user_otp.new_otp = "");

              this.otpBasedLogin();

              this.otp_based_login_dialog = false;
            } else {
              this.showSnackbar("red", res.data.status_reason);
              this.otp_based_login_dialog = false;
              (this.verify_block = false), (this.user_otp.new_otp = "");
            }
          })
          .catch((error) => {
            window.console.log(error);
            this.message = "Something went wrong";
          })
          .finally(() => {
            this.verify_btn_load = false;
            this.login = false; 
          });
      } else {
        alert("Please enter otp!!!");
      }
    },

     otpBasedLogin() {
      localStorage.setItem("Temp", this.user_otp.otp_send_username);
      
      if (this.perormLoginFormValidationForOtp()) {
        this.user_otp.dns = window.location.hostname;
        axios
          .post("/login/otpBasedLogin", this.user_otp)
          .then((res) => {
            localStorage.setItem("EPS-bypassed-by", "");
            if (res.data.msg == "200") {
              localStorage.setItem("awspath", res.data.awspath);
              localStorage.setItem("EPS-token", res.data.token);
              localStorage.setItem("EPS-refresh-token", res.data.refreshtoken);
              localStorage.setItem("EPS-tenant", res.data.tenant);
              localStorage.setItem("EPS-uid", res.data.uid);
              localStorage.setItem("EPS-org-id", res.data.orgid);
              localStorage.setItem("EPS-ut", res.data.ut);
              localStorage.setItem("EPS-org-name", res.data.org_name);
              localStorage.setItem("EPS-org-domain-id", res.data.org_domain_id);
              localStorage.setItem("username", res.data.username);
              localStorage.setItem("profile_image_path",res.data.profile_image_path);
              localStorage.setItem("profile_image_name",res.data.profile_image_name);
              localStorage.setItem("report-field",JSON.stringify(res.data.rep_fields));
              this.$session.start();
              if (res.data.policy_read == true) {
                 this.$router.push("/home");
              }
              else {
                this.dialog = true;
              }
              //window.location="/home"
            } else if (res.data.msg == "blocked") {
              //this.message = "This user is blocked!!!";
              this.showSnackbar("#C62828", "This User Is Blocked !!!");
              localStorage.setItem("EPS-token", "");
              localStorage.setItem("EPS-uid", "");
              localStorage.setItem("EPS-ut", "");
              localStorage.setItem("EPS-tenant", "");
              localStorage.setItem("EPS-org-name", "");
              localStorage.setItem("username", "");
              localStorage.setItem("profile_image_path", "");
              localStorage.setItem("profile_image_name", "");
            } else {
              //this.message = "Please check ur credentials!!!";
              this.showSnackbar("#C62828", "Please Check  Your Username..!");
              localStorage.setItem("EPS-token", "");
              localStorage.setItem("EPS-uid", "");
              localStorage.setItem("EPS-ut", "");
              localStorage.setItem("EPS-tenant", "");
              localStorage.setItem("EPS-org-name", "");
              localStorage.setItem("username", "");
              localStorage.setItem("profile_image_path", "");
              localStorage.setItem("profile_image_name", "");
            }
          })
          .catch((error) => {
            window.console.log(error);
            //this.message = "Something went wrong";
            this.showSnackbar("#C62828", "Something Went Wrong !!!");
          });
      } else {
        console.log("I am in else block");
      }
    },
     perormLoginFormValidationForOtp() {
      if (this.user_otp.otp_send_username == "") {
        return false;
      } else {
        return true;
      }
    },
    async loadCaptcha() {
      try {
        const url = process.env.VUE_APP_API_URL + `/Captcha/generate?dns=${encodeURIComponent(this.dns)}`;
        const res = await fetch(url);

        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const data = await res.json();
        console.log("CAPTCHA:", data);

        this.captchaImage = data.image;
        this.captchaToken = data.token;
        this.userCaptcha = "";
        this.message = "";
      } catch (err) {
        console.error("CAPTCHA load error:", err);
      }
    },
    async verifyCaptcha() {
      const url = process.env.VUE_APP_API_URL + `/Captcha/verify?dns=${encodeURIComponent(this.dns)}`;
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token: this.captchaToken,
          userCaptcha: this.userCaptcha,
        }),
      });
      const result = await res.json();
      this.message = result.message;
      this.success = result.success;
      if (!result.success) {
        this.loadCaptcha();
      }
    },

    perform_Change_Password_Form_Validation() {
      if (this.user_1.password == "") {
        return false;
      } else {
        return true;
      }
    },
    perform_old_password_form_validation() {
      if (this.user.oldpassword == "") {
        return false;
      } else {
        return true;
      }
    },
    async setpassword() {
      // const token = await grecaptcha.execute(
      //   "6LdpJ1orAAAAAIPDCJppHuoZgrMbHDYyGhlYqbrO",
      //   { action: "submit" }
      // );
      this.error1 = false;
      this.error_message1 = '';
      if (!this.userCaptcha) {
        this.error1 = true;
        this.error_message1 = 'Please enter CAPTCHA';
        return;
      }
      if (!this.success) {
        this.error1 = true;
        this.error_message1 = 'Please verify CAPTCHA';
        return;
      }
      if (this.perform_Change_Password_Form_Validation()) {
        const data = {
          //uid :  this.$session.get("uid"),
          uid: localStorage.getItem("Temp"),
          password: this.user_1.password,
          // token: token
        };
        axios
          .post("/login/changepassword_1", data)
          .then((res) => {
            if (res.data.msg == "200") {
              // window.alert("Password changed successfully...")
              this.showSnackbar("#4caf50", "Password changed successfully...!");
              this.update_password_dialog = false;
            } else if (res.data.flag == "No") {
              this.error1 = true;
              this.error_message1 = res.data.msg;
            }
          })
          .catch((error) => {
            window.console.log(error);
            this.message = "Something went wrong";
          });
      }
    },


    deriveBrandLight(brand) {
      const num = parseInt(brand.slice(1), 16);

      let r = (num >> 16) & 255;
      let g = (num >> 8) & 255;
      let b = num & 255;

      r = Math.round(r + (255 - r) * 0.7);
      g = Math.round(g + (255 - g) * 0.7);
      b = Math.round(b + (255 - b) * 0.7);

      return (
        "#" +
        ((1 << 24) + (r << 16) + (g << 8) + b)
          .toString(16)
          .slice(1)
      );
    },


    validateoldpassword() {
      if (this.perform_old_password_form_validation()) {
        const data = {
          uid: localStorage.getItem("Temp"),
          oldpassword: this.user_1.oldpassword,
        };

        axios
          .post("/login/checkpassword", data)
          .then((res) => {
            //window.console.log("res" + res.data.msg);
            if (res.data.msg == "200") {
              this.hideen = false;
              this.disabled = (this.disabled + 1) % 2;
              this.error_message = "";
            } else {
              this.message = "Password not Match!!!";
              this.error = true;
              this.error_message = "Old Password does not match!";
            }
          })
          .catch((error) => {
            window.console.log(error);
            this.message = "Something went wrong, Please try again later!";
          });
      } else {
        //console.log("I am in else block :: ");
        this.error = true;
        this.error_message = "Please enter current Password!";
      }
    },
    getlogo() {
      axios
        .post("/login/newLogin", {
          dns: window.location.href,
        })
        .then((res) => {
          if (res.data.flag == "YES") {
            this.trust_logo = res.data.trust_logo;
            this.school_name = res.data.school_name;
            this.logo = res.data.logo;
            this.help_details = res.data.help;
            this.school_code = res.data.school_code;
            this.learner_android_url = res.data.learner_android_url;
            this.learner_ios_url = res.data.learner_ios_url;
            this.inst_android_url = res.data.inst_android_url;
            this.inst_ios_url = res.data.inst_ios_url;
            if (Array.isArray(res.data.help)) {
              localStorage.setItem("organization_details", JSON.stringify(res.data.help));
              window.dispatchEvent(new Event("storage"));
            }
            sessionStorage.setItem("EPS-trust-logo", res.data.trust_logo);
          } else {
            sessionStorage.setItem("EPS-trust-logo", "");
            this.org.logo =
              "https://edupluscampus.com/img/logos/logo-white.png";
          }
        });
    },
    perormLoginFormValidation() {
      if (this.user.uid == "" && this.user.pass == "") {
        return false;
      } else {
        return true;
      }
    },
    getTextColorForBackground(hexColor) {
      if (!hexColor) return "#000000";

      const hex = hexColor.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
      return luminance >= 135 ? "#1e293b" : "#FFFFFF";
    },
    signIn() {
      this.login = true;
      localStorage.setItem("Temp", this.user.uid);
      if (this.perormLoginFormValidation()) {
        this.user.dns = window.location.href;
        this.user.altchaPayload = this.altchaPayload;
        axios
          .post("/login/process", this.user)
          .then((res) => {
            console.log("API Response:", res.data); // Debugging line to check response

            localStorage.setItem("EPS-bypassed-by", "");

            if (res.data.msg === "200") {
              localStorage.setItem("awspath", res.data.awspath);
              localStorage.setItem("EPS-token", res.data.token);
              localStorage.setItem("EPS-refresh-token", res.data.refreshtoken);
              localStorage.setItem("EPS-tenant", res.data.tenant);
              localStorage.setItem("EPS-uid", res.data.uid);
              localStorage.setItem("EPS-org-id", res.data.orgid);
              localStorage.setItem("EPS-ut", res.data.ut);
              localStorage.setItem("EPS-org-name", res.data.org_name);
              localStorage.setItem("EPS-org-domain-id", res.data.org_domain_id);
              localStorage.setItem("organization_code",res.data.organization_code);
              localStorage.setItem("username", res.data.username);
              localStorage.setItem("preferred_lang", res.data.preferred_lang);
              localStorage.setItem(
                "profile_image_path",
                res.data.profile_image_path
              );
              localStorage.setItem(
                "profile_image_name",
                res.data.profile_image_name
              );
              localStorage.setItem(
                "report-field",
                JSON.stringify(res.data.rep_fields)
              );
              localStorage.setItem("hasChildren", res.data.hasChildren);
              localStorage.setItem("is_unicode_note", res.data.is_unicode_note);
              if (res.data.payment_due_date) {
                localStorage.setItem(
                  "payment_due_date",
                  res.data.payment_due_date
                );
              }
              this.$session.start();


              if (res.data.theme_color) {
                const brand = res.data.theme_color;
                const brandLight = this.deriveBrandLight(brand);
                const onBrand = this.getTextColorForBackground(brand);

                localStorage.setItem("theme_color", brand);
                localStorage.setItem("theme_color_light", brandLight);
                localStorage.setItem("theme_text", onBrand);

                this.$vuetify.theme.currentTheme.brand = brand;
                this.$vuetify.theme.currentTheme.brandLight = brandLight;
                this.$vuetify.theme.currentTheme.onBrand = onBrand;
              }


              if (res.data.policy_read) {
                this.$router.push("/home");
              } else {
                this.dialog = true;
              }
              this.login = false;
            } else if (res.data.flag === "No") {
              //alert("res.data.change_password" + res.data.change_password)
              if (
                res.data.change_password &&
                res.data.change_password == true
              ) {
                this.showSnackbar(
                  "#C62828",
                  "Username And Password Cannot Be The Same... Please Change Your Password!"
                );
                this.update_password_dialog = true;
              } else {
                console.log("Payment due date flag detected"); // Debugging line
                this.showSnackbar(
                  "#C62828",
                  res.data.snackbar || "Your payment is overdue."
                );
                return;
              }
              this.login = false;
            } else if (res.data.msg === "blocked") {
              this.showSnackbar("#C62828", "This User Is Blocked!");
              this.clearLocalStorage();
              this.login = false;
            } else if (res.data.flag === "IP_BLOCKED") {
              this.showSnackbar(
                "#C62828",
                "You are not allowed to Login on this device..!"
              );
              this.clearLocalStorage();
              this.login = false;
            }else if(res.data.flag === "OTP_REQUIRED"){
              this.bothVerificationMode = false;
              this.open_dialog_for_send_otp();
                          
            }else if (res.data.flag_both === "BOTH_REQUIRED") {
                
                console.log("inside BOTH_REQUIRED==========");
                this.bothVerificationMode = true;
                this.user_otp.otp_send_username = this.user.uid;
                this.user_otp.otp_send_password = this.user.pass;

                this.qrModal = true;
                this.activeVerificationTab = 0;
                this.emailOtpSent = false;

                if(res.data.flag === "MFA_SETUP_REQUIRED"){
                  this.qrModal = true;
                  this.mfaSetupMode = true;
                  this.qrdetails = res.data.url;
                  this.mfaSecret = res.data.secret; 
                  this.totpCode = "";
                  this.showSnackbar("#C62828", res.data.msg);
                  this.login = false;
                }else if (res.data.flag === "MFA_TOTP_REQUIRED") {
                  this.qrModal = true;
                  this.mfaSetupMode = false;
                  this.qrdetails = "";
                  this.mfaSecret = "";
                  this.totpCode = "";
                  this.showSnackbar("#C62828", res.data.msg);
                  this.login = false;
                }
            }
            else if (res.data.flag === "MFA_SETUP_REQUIRED") {
              this.qrModal = true;
              this.mfaSetupMode = true;
              this.bothVerificationMode = false;
              this.qrdetails = res.data.url;
              this.mfaSecret = res.data.secret; 
              this.totpCode = "";
              this.showSnackbar("#C62828", res.data.msg);
              this.login = false;
            } 
            else if (res.data.flag === "MFA_TOTP_REQUIRED") {
              this.qrModal = true;
              this.mfaSetupMode = false;
              this.bothVerificationMode = false;
              this.qrdetails = "";
              this.mfaSecret = "";
              this.totpCode = "";
              this.showSnackbar("#C62828", res.data.msg);
              this.login = false;
            }
            else {
              console.log("Unknown response, falling to default case"); // Debugging line
              this.showSnackbar("#C62828", res.data.msg || "Please Check Your Credentials!");
              this.clearLocalStorage();
              this.login = false;
            }
          })
          .catch((error) => {
            console.error("Login error:", error);
            this.showSnackbar("#C62828", "Something Went Wrong!");
            this.login = false;
          });
      } else {
        console.log("I am in else block");
        this.login = false;
      }
    },
    readPolicy() {
      this.read_policy_load = true;
      axios
        .post("/login/readPolicy", this.user)
        .then((res) => {
          window.console.log("res" + res.data.msg);
          if (res.data.msg == "200") {
            this.$router.push("/home");
          }
        })
        .catch((error) => {
          window.console.log(error);
          this.message = "Something went wrong";
        })
        .finally(() => {
          this.dialog = false;
          this.read_policy_load = false;
        });
    },
    clearLocalStorage() {
      localStorage.setItem("EPS-token", "");
      localStorage.setItem("EPS-uid", "");
      localStorage.setItem("EPS-ut", "");
      localStorage.setItem("EPS-tenant", "");
      localStorage.setItem("EPS-org-name", "");
      localStorage.setItem("username", "");
      localStorage.setItem("profile_image_path", "");
      localStorage.setItem("profile_image_name", "");
    },
    openDialog() {
      this.showDialog = true;
    },
    closeDialog() {
      this.showDialog = false;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    validateMfa() {
      if (!this.totpCode) {
        this.showSnackbar("#C62828", "Please enter 6 digit code");
        return;
      }
      
      if (this.totpCode.length !== 6) {
        this.showSnackbar("#C62828", "Invalid code");
        return;
      }

      this.mfaLoading = true;

      const data = {
        username: this.user.uid,
        password: this.user.pass,
        code: this.totpCode,
        secretval: this.mfaSecret,
        altchaPayload : this.altchaPayload
      };

      axios.post("/login/validatemfa", data)
        .then((res) => {

          if (res.data.status == "200") {
            this.showSnackbar("green","Your account has been successfully verified! Please log in again to continue.")
            this.qrModal=false
          } else {
            this.showSnackbar("#C62828",res.data.msg || "Invalid authentication code");
          }
        })
        .catch(() => {
          this.showSnackbar("#C62828","Something went wrong");
        })
        .finally(() => {
          this.mfaLoading = false;
        });
    },

    verifyMfaLogin() {
      if (!this.totpCode) {
        this.showSnackbar("#C62828", "Please enter 6 digit code");
        return;
      }

      if (this.totpCode.length !== 6) {
        this.showSnackbar("#C62828", "Invalid code");
        return;
      }
     
      const data = {
        username: this.user.uid,
        password: this.user.pass, 
        otp: this.totpCode,
        altchaPayload: this.altchaPayload,
        type:"YES"
      };

      axios.post("/login/verifyMfaLogin", data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.qrModal = false;

            localStorage.setItem("awspath", res.data.awspath);
            localStorage.setItem("EPS-token", res.data.token);
            localStorage.setItem("EPS-refresh-token", res.data.refreshtoken);
            localStorage.setItem("EPS-tenant", res.data.tenant);
            localStorage.setItem("EPS-uid", res.data.uid);
            localStorage.setItem("EPS-org-id", res.data.orgid);
            localStorage.setItem("EPS-ut", res.data.ut);
            localStorage.setItem("EPS-org-name", res.data.org_name);
            localStorage.setItem("EPS-org-domain-id", res.data.org_domain_id);
            localStorage.setItem("username", res.data.username);
            localStorage.setItem("profile_image_path",res.data.profile_image_path);
            localStorage.setItem("profile_image_name",res.data.profile_image_name);
            localStorage.setItem("report-field",JSON.stringify(res.data.rep_fields));
            this.$session.start();
            if (res.data.policy_read) {
              this.$router.push("/home");
            } else {
              this.dialog = true;
            }
            this.showSnackbar("green", "Login successful");
          }else if (res.data.msg == "blocked") {
              this.showSnackbar("#C62828", "This User Is Blocked !!!");
              localStorage.setItem("EPS-token", "");
              localStorage.setItem("EPS-uid", "");
              localStorage.setItem("EPS-ut", "");
              localStorage.setItem("EPS-tenant", "");
              localStorage.setItem("EPS-org-name", "");
              localStorage.setItem("username", "");
              localStorage.setItem("profile_image_path", "");
              localStorage.setItem("profile_image_name", "");
          }else {
             this.showSnackbar("#C62828", res.data.msg || "Invalid authentication code");
              localStorage.setItem("EPS-token", "");
              localStorage.setItem("EPS-uid", "");
              localStorage.setItem("EPS-ut", "");
              localStorage.setItem("EPS-tenant", "");
              localStorage.setItem("EPS-org-name", "");
              localStorage.setItem("username", "");
              localStorage.setItem("profile_image_path", "");
              localStorage.setItem("profile_image_name", "");
            }
          })
        .catch(() => {
          this.showSnackbar("#C62828", "Something went wrong");
        })
        .finally(() => {
          this.mfaLoading = false;
        });
    },
    handleMfaSubmit() {
      if (this.mfaSetupMode) {
        // this.validateMfa(); 
        this.triggerValidateMfa();       
      } else {
        // this.verifyMfaLogin();
        this.triggerVerifyMfaLogin();     
      }
    },

    // executeAltcha() {
    //   this.altchaPayload = null;

    //   const altchaEl = this.$refs.altcha;

    //   if (!altchaEl) {
    //     this.pendingAction = null;
    //     this.login = false;
    //     this.send_otp_btn_load = false;
    //     this.mfaLoading = false;
    //     this.showSnackbar("#C62828", "ALTCHA widget not found.");
    //     return;
    //   }

    //   if (typeof altchaEl.reset !== "function" || typeof altchaEl.verify !== "function") {
    //     this.pendingAction = null;
    //     this.login = false;
    //     this.send_otp_btn_load = false;
    //     this.mfaLoading = false;
    //     this.showSnackbar("#C62828", "ALTCHA is not initialized.");
    //     return;
    //   }

    //   altchaEl.reset();

    //   this.$nextTick(() => {
    //     altchaEl.verify();
    //   });
    // },

    executeAltcha() {
      if (this.$refs.altcha) {
        this.$refs.altcha.reset(); // Clear old burned payload

        // Small timeout allows widget to reset before verifying again
        setTimeout(() => {
          this.$refs.altcha.verify();
        }, 50);
      } else {
        this.resetLoaders();
        this.$refs.snackbar.showSnackbar(
          "red",
          "Security verification widget not found."
        );
      }
    },

    triggerSignIn() {
      if (!this.perormLoginFormValidation()) {
        this.showSnackbar("#C62828", "Please enter credentials!");
        return;
      }

      this.login = true;
      this.pendingAction = "signIn";
      this.executeAltcha();
    },

    triggerSendOtp() {
      if (!this.user_otp.otp_send_username || !this.user_otp.otp_send_password) {
        this.showSnackbar("#C62828", "Please enter both Username and Password!");
        return;
      }

      this.send_otp_btn_load = true;
      this.pendingAction = "sendOtp";
      this.executeAltcha();
    },

    triggerValidateMfa() {
      if (!this.totpCode || this.totpCode.length !== 6) {
        this.showSnackbar("#C62828", "Please enter a valid 6-digit code");
        return;
      }

      this.mfaLoading = true;
      this.pendingAction = "validateMfa";
      this.executeAltcha();
    },

    triggerVerifyMfaLogin() {
      if (!this.totpCode || this.totpCode.length !== 6) {
        this.showSnackbar("#C62828", "Please enter a valid 6-digit code");
        return;
      }

      this.mfaLoading = true;
      this.pendingAction = "verifyMfaLogin";
      this.executeAltcha();
    },

    // Called automatically by altcha-widget
    onAltchaStateChange(event) {
      const { state, payload } = event.detail;

      if (state === "verified") {
        if (!payload) {
          this.pendingAction = null;
          this.login = false;
          this.send_otp_btn_load = false;
          this.mfaLoading = false;
          this.showSnackbar("#C62828", "ALTCHA payload is missing.");
          return;
        }

        this.altchaPayload = payload;
        const action = this.pendingAction;
        this.pendingAction = null;

        if (action === "signIn") {
          this.signIn();
        } else if (action === "sendOtp") {
          this.sendotp();
        } else if (action === "validateMfa") {
          this.validateMfa();
        } else if (action === "verifyMfaLogin") {
          this.verifyMfaLogin();
        }
      } else if (state === "error") {
        this.altchaPayload = null;
        this.pendingAction = null;
        this.login = false;
        this.send_otp_btn_load = false;
        this.mfaLoading = false;
        console.error("ALTCHA error:", event.detail);
        this.showSnackbar("#C62828","Security verification failed. Please try again.");
      } else if (state === "expired") {
        this.altchaPayload = null;
      }
    },
  },
};
</script>

<style scoped>
.yellow-theme {
  color: #f39c12 !important;
}

.blue-theme {
  color: #292dc2 !important;
}

.logo {
  height: 90px;
  width: 90px;
}

.custom-table-header th {
  background-color: navy !important;
  color: white !important;
}

.text-h1 {
  font-size: 32px;
  font-weight: bold;
  font-family: "Times New Roman", Times, serif;
  /* text-transform: uppercase; */
}

.card {
  width: 190px;
  height: 25px;
  border-radius: 20px;
  background: #f5f5f5;
  position: relative;
  padding: 1.3rem;
  border: 2px solid #c3c6ce;
  transition: 0.5s ease-out;
  overflow: visible;
}

.card-details {
  color: black;
  height: 10%;
  display: grid;
  place-content: center;
}

.text-title {
  font-size: 19px;
  font-weight: bold;
  transition: font-size 0.3s ease;
  margin-bottom: 0px;
}

.text-title.shrink {
  font-size: 14px;
  margin-bottom: 15px;
}

.card-button {
  transform: translate(-50%, 125%);
  width: 60%;
  border-radius: 1rem;
  border: none;
  background-color: #008bf8;
  color: #fff;
  font-size: 11px;
  padding: 0.25rem 0.5rem;
  position: absolute;
  left: 50%;
  bottom: 0;
  opacity: 0;
  transition: 0.3s ease-out;
}

/* Hover & load shared animation */
.card.hover-effect,
.card:hover {
  border-color: #008bf8;
  box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.25);
}

.card.hover-effect .card-button,
.card:hover .card-button {
  transform: translate(-50%, 50%);
  opacity: 1;
}

.text-decoration-underline {
  text-decoration: underline;
  color: #3949ab;
}

.pointer-cursor {
  cursor: pointer;
}

.component {
  position: relative;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
}

.dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  z-index: 11;
  height: 70%;
  width: 80%;
}

.error-message {
  color: red;
  font-size: 14px;
  font-weight: 900;
  padding-left: 7%;
}

.sidebar-link {
  text-decoration: none;
}

.sidebar-link-item:hover {
  background-color: rgb(181, 186, 190) !important;
}

.pull-right {
  position: relative;
  text-align: center;
}

.error-message {
  color: red;
  font-size: 14px;
  font-weight: 900;
  padding-left: 7%;
}

.captcha-container {
  text-align: center;
}

.captcha-image {
  cursor: pointer;
  max-height: 50px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.captcha-input-row {
  display: flex;
  align-items: center;
  gap: 10px;
  /* Space between input and button */
  margin-top: 10px;
  margin-bottom: 5px;
}

.captcha-input {
  margin: 0 !important;
}

.captcha-verify-btn {
  margin: 0 !important;
  height: 40px;
  /* Match the height of the text field */
  padding: 0 16px;
  /* Adjust padding for better appearance */
}

.captcha-message {
  margin-top: 5px;
  font-weight: bold;
}
</style>